export default __webpack_public_path__ + "static/assets/52c6fce72f8f80170c10d2f604e4cd65.png";